const getTotalItemsInCart = cart =>
	cart.orderItems
		.filter(item => item.visible)
		.map(item => item.quantityRequired)
		.reduce((a, b) => a + b, 0);

export default getTotalItemsInCart;
